module.exports = __webpack_public_path__ + "static/img/rudy.a15ea6b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial/rudy.jpeg
// module id = I3nk
// module chunks = 1